import scraperApi from "api";
import Toaster from "components/Toaster";
import { getFileExtension } from "pages/crawler/utils/fileUtils";

/**
 * Downloads crawler job data in the specified format
 */
export const downloadJobData = async (
  jobId: string,
  outputFormat: string = 'json'
): Promise<void> => {
  try {
    // Use the streaming download API with format parameter
    const response = await scraperApi.crawlers.downloadCrawlerJobDataStream(
      jobId,
      outputFormat
    );

    // Handle the blob response directly (streaming data)
    const blob =
      response instanceof Blob
        ? response
        : new Blob([JSON.stringify(response, null, 2)], {
            type: 'application/json',
          });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // Use appropriate file extension based on format
    const fileExtension = getFileExtension(outputFormat);
    link.download = `crawler-job-${jobId}-data.${fileExtension}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    Toaster.success('Download completed');
  } catch (error) {
    console.error('Failed to download job data:', error);
    Toaster.error('Failed to download job data');
    throw error;
  }
};

/**
 * Downloads all crawler job results as a ZIP file
 */
export const downloadAllJobResults = async (
  jobId: string,
  outputFormat: string = 'json'
): Promise<void> => {
  try {
    // Use the download-all API endpoint
    const response = await scraperApi.crawlers.downloadAllCrawlerJobResults(
      jobId,
      outputFormat
    );

    // Handle the blob response directly (streaming data)
    const blob =
      response instanceof Blob
        ? response
        : new Blob([JSON.stringify(response, null, 2)], {
            type: 'application/zip',
          });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `crawler-job-${jobId}-results.zip`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    Toaster.success('Download completed');
  } catch (error) {
    console.error('Failed to download all job results:', error);
    Toaster.error('Failed to download all job results');
    throw error;
  }
};

